import { GetDealByIdQuery } from '@/lib/graphql/generated/graphql';

export enum ExportStatus {
  Completed = 'completed',
  Error = 'error',
  Pending = 'pending',
}

export interface ExportError {
  step: string;
  code?: string;
  operation?: string;
  documentTitle?: string;
  fileId?: string;
}

export type DealSelectionExportFromQuery = NonNullable<
  GetDealByIdQuery['deal']
>['selectionExports'][number];
